import { render } from "./task-complete.vue?vue&type=template&id=1c8b0920"
import script from "./task-complete.vue?vue&type=script&lang=js"
export * from "./task-complete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__